export var PaceType;
(function (PaceType) {
    PaceType[PaceType["MinutesPerKilometer"] = 1] = "MinutesPerKilometer";
    PaceType[PaceType["KilometersPerHour"] = 2] = "KilometersPerHour";
})(PaceType || (PaceType = {}));
export const getPaceTypeLabel = (type) => {
    switch (type) {
        case PaceType.MinutesPerKilometer:
            return 'min/km';
        case PaceType.KilometersPerHour:
            return 'km/h';
    }
    return '';
};
export const convertSpeedToPace = (paceType, speed, withSuffix = true) => {
    const suffix = withSuffix ? ` ${getPaceTypeLabel(paceType)}` : '';
    if (paceType === PaceType.MinutesPerKilometer) {
        if (!speed) {
            return `-${suffix}`;
        }
        const pace = 1000 / (speed * 60);
        const minutes = Math.floor(pace);
        const seconds = Math.round((pace - minutes) * 60);
        return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}${suffix}`;
    }
    if (speed === null) {
        return `-${suffix}`;
    }
    return ((speed * 3600) / 1000).toLocaleString('de-DE', { maximumFractionDigits: 1 });
};
//# sourceMappingURL=PaceType.js.map